import { SelectOption } from 'src/components/common/Select';
import { STATUS_TYPE } from 'src/domains/medical-record/value-object/StatusType';

export const statusOptions: SelectOption[] = [
  { value: STATUS_TYPE.PRESENT, label: 'Présent' },
  { value: STATUS_TYPE.ABSENT, label: 'Absent' },
];
